module.exports = __webpack_public_path__ + "img/694161d4fbabf6c0a310d388581690b7.694161d4.png";